import { ExportEncoding } from '../../types';

const resolveXmlEncodingName = (encoding: ExportEncoding): string =>
  encoding === 'ascii' ? 'ASCII' : encoding;

export default resolveXmlEncodingName;
